<div class="row">
    <div class="form-group col-md-6 col-lg-6 col-sm-12 col-xs-12 datepicker-custom ">
        <div class="form-group">
            <label for="idCategoria" style="color: #fff !important">Fascia Oraria:</label>
            <select (change)="globalData.onFasciaOrariaChange()" #fasciaOraria
                [(ngModel)]="globalData.fasciaOrariaSelezionata" class="form-control">
                <option value='1'>Intera Giornata</option>
                <option value='2'>Mattina</option>
                <option value='3'>Pomeriggio</option>

            </select>
        </div>

        <div class="form-inline">
            <div class="form-group">
                <input autocomplete="off" class="form-control " (click)="d.toggle()" placeholder="gg-mm-aaaa" name="dp"
                    [(ngModel)]="globalData.datePicker.dataSelezionata" ngbDatepicker #d="ngbDatepicker">
                <button (click)="globalData.aggiornaCalendarioOmbrelloni(globalData.datePicker.dataSelezionata)"
                    skipLocationChange=true
                    [disabled]="globalData.fasciaOrariaSelezionata == '' || globalData.fasciaOrariaSelezionata == undefined || globalData.datePicker.dataSelezionata == null"
                    class="btn btn-primary">Scegli
                    una data</button>
            </div>
        </div>


    </div>
</div>